module.exports = __webpack_public_path__ + "static/media/blackArrowUp.38d1c8fa.svg";